import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SwitcherProps, switcherStyles } from '@kite_aerolab/shared/components';
import { getRandomID } from '@kite_aerolab/shared/utils';

@Component({
  selector: 'kite-switcher',
  template: `
    <div [ngClass]="switcherStyles" (click)="handleFocus($event)" (keyup)="handleFocus($event)">
      <label class="switch" [for]="id">
        <input
          [id]="id"
          [disabled]="isDisabled"
          type="checkbox"
          [checked]="isOn"
          (change)="onChange.emit($event)"
          (click)="onClick.emit($event)"
        />
        <span class="slider" [attr.aria-hidden]="true"></span>
      </label>
      <label
        [for]="id"
        [id]="id + '-label'"
        class="switch-label-container"
        *ngIf="label"
        [ngClass]="labelPosition === 'right' ? 'label-container-right' : 'label-container-left'"
      >
        <span kiteText size="sm" [variant]="isDisabled ? 'body' : 'subtitle'">{{ label }}</span>
        <kite-icon
          *ngIf="icon"
          [name]="icon"
          [aria-label]="icon + ' icon'"
          size="md"
          [class]="isDisabled ? 'disabled' : ''"
        ></kite-icon>
      </label>
    </div>
  `,
})
export class SwitcherComponent {
  focusable = false;
  /**
   * ID del switch.
   */
  @Input() id: string = getRandomID();

  /**
   * Estado deshabilitado del switch
   */
  @Input() isDisabled: SwitcherProps['isDisabled'];

  /**
   * Label del switch
   */
  @Input() label: SwitcherProps['label'];

  /**
   * Ícono que acompaña la label
   */
  @Input() icon: SwitcherProps['icon'];

  /**
   * Posición de la label (izquierda o derecha)
   */
  @Input() labelPosition: SwitcherProps['labelPosition'];

  /**
   * Css
   */
  @Input() css: SwitcherProps['css'];

  /**
   * Css
   */
  @Input() isOn: SwitcherProps['isOn'];

  @Output() onClick: EventEmitter<any> = new EventEmitter();
  @Output() onChange: EventEmitter<any> = new EventEmitter();

  public get switcherStyles(): string[] {
    return [
      switcherStyles({
        css: this.css,
        isFocusable: this.focusable,
      }).className,
    ];
  }

  handleFocus(event: any) {
    this.focusable = !!event.key;
  }
}
